import React, { useState, useEffect } from "react";
import Loading from "../components/Loading";
import { FaReply, FaTimes } from "react-icons/fa";
import axios from "axios";
import { getToken } from "../slice/tokenSlice";
import { useDispatch, useSelector } from "react-redux";

const ToDo = () => {
  const dispatch = useDispatch();
  const { user, url } = useSelector((state) => state.user);
  const { token } = useSelector((state) => state.token);
  //
  const [entries, setEntries] = useState([]);
  const [loading, setloading] = useState(true);
  const getToDo = async () => {
    try {
      const res = await axios.get(
        `${url}/proxy?url=https://www.zohoapis.in/crm/v2/SD_Portal/search?criteria=((Lead_Name:equals:${user.id}))`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Zoho-oauthtoken ${token}`,
          },
        }
      );
      if (res.status === 200) {
        res.data.data.forEach((item) => {
          let date = "";
          let time = "";
          date = item.Created_Time.split("T")[0].split("-").reverse().join("-");
          time = item.Created_Time.split("T")[1].split("+")[0];
          item.Created_Time = `${date} at ${time}`;
          //
        });
        const filtered = res.data.data.filter((item) => {
          return item.Client_Comments === null;
        });
        setEntries(filtered);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setloading(false);
    }
  };
  useEffect(() => {
    dispatch(getToken());
  }, []);
  useEffect(() => {
    if (token !== null) {
      getToDo();
    }
  }, [token]);
  //
  const [showReply, setShowReply] = useState(false);
  const [replyID, setReplyID] = useState("");
  const [replyInput, setReplyInput] = useState("");
  //
  useEffect(() => {
    if (replyID !== "") {
      setShowReply(true);
    } else {
      setShowReply(false);
    }
  }, [replyID]);
  const sendReply = async () => {
    const data = [
      {
        Client_Comments: replyInput,
      },
    ];
    try {
      const res = await axios.put(
        `${url}/proxy?url=https://www.zohoapis.in/crm/v2/SD_Portal/${replyID}`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Zoho-oauthtoken ${token}`,
          },
        }
      );
      if (res.status === 200) {
        setReplyID("");
        setReplyInput("");
        getToDo();
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <div className="container p-2 py-4">
        <div className="text-center mb-3">
          <h2>To Do</h2>
          <p>Below are the informations we require from your end.</p>
        </div>
        {loading ? (
          <Loading />
        ) : (
          <>
            {entries.length !== 0 ? (
              <>
                {entries.map((item, index) => {
                  return (
                    <div
                      className={`border bg-white rounded p-2 ${
                        index === entries.length - 1 ? "" : "mb-2"
                      }`}
                      key={index}
                    >
                      <p>
                        <span className="fw-bold">Title</span>: {item.Title}
                      </p>
                      <p className="my-2">
                        <span className="fw-bold">Agent message</span>:
                        {item.Agent_Comments}
                      </p>
                      <p>
                        <span className="fw-bold">Date & Time</span>:
                        {item.Created_Time}
                      </p>
                      <div className="reply-flex">
                        {showReply && replyID === item.id ? (
                          <>
                            <div>
                              <input
                                type="text"
                                className="form-input"
                                value={replyInput}
                                onChange={(e) => setReplyInput(e.target.value)}
                              />
                            </div>
                            <div>
                              <button
                                className="button d-flex align-items-center justify-content-center w-100"
                                onClick={() => sendReply(item.id)}
                              >
                                Submit
                                <FaReply className="ms-2" />
                              </button>
                            </div>
                            <div>
                              <button
                                className="button w-100 text-center"
                                onClick={() => setReplyID("")}
                              >
                                Cancel <FaTimes />
                              </button>
                            </div>
                          </>
                        ) : (
                          <></>
                        )}
                        {!showReply ? (
                          <div>
                            <button
                              className="button reply-button"
                              onClick={() => setReplyID(item.id)}
                            >
                              <FaReply className="me-2" />
                              Reply
                            </button>
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>
                  );
                })}
              </>
            ) : (
              <p className="text-center my-4">No data found</p>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default ToDo;
